<template>
  <ValidationObserver ref="validator">
    <form ref="form" @submit.prevent="onSubmit">
      <div class="row px-5">
        <div class="col-12">
          <TextField
            id="companyName"
            name="companyName"
            :label="`${translate('rwCompanyName')} (${translate('rwOptional')})`"
            data-testid="companyName"
            :rules="{ max: 16 }"
          />
        </div>

        <DynamicCheckboxes :checkboxes="checkboxes" cssClass="col-12 dynamic-checkbox" />
        <FriendlyRecaptcha
          v-if="isFriendlyCaptchaEnable"
          class="col-12 pt-3"
          location="signup"
          @widget-completed="onFriendlyCaptchaCompleted"
          @widget-error="onFriendlyCaptchaError"
          @widget-expire="onFriendlyCaptchaExpire"
          @widget-reset="onFriendlyCaptchaReset"
          @reset-action="onSetResetAction"
        />
        <div class="col-12 text-center d-flex pt-5">
          <button
            class="btn btn-primary text-uppercase join-submit-btn text-bold"
            :class="loading ? 'm-progress' : ''"
            :disabled="!isSubmitEnabled"
            type="submit"
          >
            {{ translate('rwSubmit') }}
          </button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import TextField from '@/components/form-controls/TextField'
import DynamicCheckboxes from '@/components/form-controls/DynamicCheckboxes'
import formJson from 'form-json'
import dynamicCheckBoxes from '@/components/mixins/dynamicCheckBoxes'
import FriendlyCaptchaMixin from '@/components/mixins/FriendlyRecaptcha'
import { mapActions } from 'vuex'
import FriendlyRecaptcha from '@/components/form-controls/FriendlyRecaptcha.vue'
import { consentPiplEnabled } from '@/infrastructure/Configuration'
import { getPiplCheckboxLabel, getPageLanguage } from '@/infrastructure/Utils'

export default {
  name: 'Step2MeetingPlanner',
  components: {
    ValidationObserver,
    TextField,
    DynamicCheckboxes,
    FriendlyRecaptcha
  },
  mixins: [dynamicCheckBoxes, FriendlyCaptchaMixin],
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    isChina: Boolean,
    selectedCountry: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checkboxes: []
    }
  },
  computed: {
    isFriendlyCaptchaEnable() {
      return global.ConfigDynamic.isEnabled(global.ConfigDynamicKey.WEB_FRIENDLY_CAPTCHA_B2B)
    },
    isSubmitEnabled () {
      return this.isFriendlyCaptchaEnable ? this.isCaptchaCompleted : true
    },
    signupType() {
      return 'b2b'
    },
    linkPrivacyNotice() {
      return `<button role="button" aria-label="link-privacy-policy" class="btn btn-link btn-link--inline" data-target="#modal-default" data-href="/${getPageLanguage().toLowerCase()}/system/include/modal/privacy-policy#loyalty-programs">${this.translate(
        'peCheckboxPIPLPrivacyNotice'
      )}</button>`
    },
    lblBoCheckboxPIPL() {
      return getPiplCheckboxLabel(this.translate, this.linkPrivacyNotice)
    }
  },
  methods: {
    ...mapActions(['trackErrorEventB2BEnrollment', 'sendStep2Analytics']),
    async onSubmit(event) {
      event.preventDefault()
      const isOk = await this.$refs.validator.validate()
      if (isOk) {
        const json = formJson(event.target)

        if (this.isFriendlyCaptchaEnable) {
          json.cToken = this.captchaToken
        }

        this.$emit('submitMP', { json, callback: this.onResetCaptcha })
      } else {
        this.trackErrorEventB2BEnrollment({ error: this.$refs.validator.errors })
      }
    },
    consentPiplEnabled
  },
  async mounted() {
    this.sendStep2Analytics()
    this.checkboxes = [
      {
        label: this.lblTermsAndConditions,
        rules: 'checked',
        name: 'customer.termsAndConditions',
        id: 'terms-conditions',
        checked: false,
        dataTestid: 'terms-conditions'
      },
      {
        label: this.lblPrivacyPolicy,
        rules: 'checked',
        name: 'customer.privacyPolicy',
        id: 'privacy-policy',
        checked: false,
        dataTestid: 'privacy-policy'
      },
      {
        label: this.lblMarketingEmailsConsent,
        name: 'customer.marketingEmailsConsent',
        id: 'marketing-emails',
        checked: false,
        dataTestid: 'marketing-emails'
      }
    ]

    if (this.consentPiplEnabled(this.selectedCountry || global.AkamaiService.userCountry())) {
      this.checkboxes.push({
        label: this.lblBoCheckboxPIPL,
        rules: 'checked',
        name: 'customer.consentPIPL',
        id: 'checkboxPIPL',
        checked: false,
        dataTestid: 'checkboxPIPL'
      })
    }
  }
}
</script>

<style lang="scss">
.dynamic-checkbox {
  label.checkbox-field {
    font-size: 1.4rem;
    color: color('dark-grey');
    button.btn.btn-link {
      color: color('black');
      font-weight: bold;
      &:hover {
        color: color('black');
      }
    }
  }
}
</style>
